import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';

@Component({
    selector: 'body',
    template: `
    <ngx-loading-bar></ngx-loading-bar>
    <router-outlet></router-outlet>
    `,
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet, LoadingBarModule]
})
export class AppComponent {}
